export default function registerCartStore(Alpine) {
    Alpine.store('cart', {
        items: [],
        selected: [],

        total: 0,
        totalWeight: 0,
        discountTotal: 0,
        count: 0,

        /* ========== sync from backend ========== */
        sync(cart) {
            this.items = cart.items ?? [];
            this.total = cart.total ?? 0;
            this.totalWeight = cart.total_weight ?? 0;
            this.discountTotal = cart.discount_total ?? 0;
            this.count = cart.count ?? this.items.reduce(
                (sum, i) => sum + (i.quantity ?? 0), 0
            );

            this.selected = this.selected.filter(id =>
                this.items.some(i => i.id === id)
            );
        },

        /* ========== selection ========== */
        toggle(id) {
            this.selected.includes(id)
                ? this.selected = this.selected.filter(i => i !== id)
                : this.selected.push(id);
        },

        selectAll() {
            this.selected = this.items.map(i => i.id);
        },

        clearSelection() {
            this.selected = [];
        },

        isSelected(id) {
            return this.selected.includes(id);
        },

        get selectedCount() {
            return this.selected.length;
        },

        /* ========== helpers ========== */
        item(id) {
            return this.items.find(i => i.id === id);
        },
    });
}
